module.exports = __webpack_public_path__ + "img/ic_24_team_fussball.1cf9814b.svg";